import { FC } from 'react'

import { LogoProps } from '@assets/logo/types'

export const TMGrayLogo: FC<LogoProps> = (props) => {
  const { className } = props

  return (
    <svg
      width='29'
      height='26'
      className={className}
      viewBox='0 0 29 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.0957 0C20.1786 3.6821e-05 20.2586 0.00983095 20.3398 0.0166016L16.5361 6.60449H11.7471C11.1655 6.60456 10.6278 6.91537 10.3379 7.41895L7.58594 12.1865C7.29602 12.6901 7.29613 13.3109 7.58594 13.8145L10.3379 18.583C10.6278 19.0866 11.1655 19.3974 11.7471 19.3975H16.5381V19.3955L20.3408 25.9834C20.2597 25.9902 20.1785 26 20.0957 26H8.90527C7.72341 26 6.63088 25.3699 6.03906 24.3457L0.443359 14.6543C-0.148407 13.6301 -0.148404 12.3699 0.443359 11.3457L6.03906 1.6543C6.63088 0.63014 7.72341 0 8.90527 0H20.0957ZM22.9609 1.6543L28.5566 11.3457V11.3477C29.1483 12.3718 29.1484 13.6321 28.5566 14.6562L22.9609 24.3467C22.9202 24.4179 22.871 24.483 22.8252 24.5508L19.0215 17.9629L21.416 13.8145C21.7058 13.3109 21.7059 12.69 21.416 12.1865L19.0195 8.03711L22.8232 1.44922C22.869 1.517 22.9186 1.58313 22.9609 1.6543Z'
        fill='var(--text-low-em)'
      />
    </svg>
  )
}
